import { ArrowDown } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTheme } from "../../../../../ThemeContext/ThemeContext"; // Importing the theme context
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { format } from 'date-fns';
import Pagination from "../../../../Layout/Pagination/PaginationBar"
import ExportArrow from '../../../../../../../assets/Admin/ActivityLog/exportArrow.svg'



export default function UserActivityLog() {
  const [data, setData] = useState([]);
  const { isDarkMode, isLangArab } = useTheme(); // Access dark mode from theme context
  const [totalItems, setTotalItems] = useState(0); // Example total items count
  // const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9; // Number of items per page

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateError, setDateError] = useState("");
  const [selectedUser, setSelectedUser] = useState("");

  const [sortConfig, setSortConfig] = useState({
    key: "",
    direction: "asc",
  });

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage);
    console.log(`Selected page: ${selectedPage}`);
    // Here, you can load data for the selected page if using an API
  };
  // console.log("Passed Activity log data :", data)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(`${process.env.REACT_APP_API_URL}/UserActivityLog/Getuseractivitylogs`, {
          method: 'GET', // or any other method like POST if needed
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json', // Optionally specify content type
          }
        });
        //const response = await fetch(`${process.env.REACT_APP_API_URL}/UserActivityLog/Getuseractivitylogs`); // Example API
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        if (result.success) {
          const sortedItems = result.data.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
          setTotalItems(sortedItems.length)
          setData(sortedItems);
        }
        else {
          console.log(result.message)
        }
      } catch (error) {
        //setError(error.message);
        console.log(error)
      } finally {
        //setLoading(false);
      }
    };

    fetchData();
  }, []);
  //},[data]);

  const handleExport = () => {
    const filename = "User-Activity-Logs";

    // Assuming 'data' is your array of objects
    //const formattedData = data.map(item => {
    const formattedData = filteredData.map(item => {
      const formattedItem = { ...item };
      // Format CreatedAt and UpdatedAt dates if they exist
      if (formattedItem.createdDate) {
        formattedItem.createdDate = format(new Date(`${formattedItem.createdDate}Z`), 'MM/dd/yyyy, h:mm:ss a');
      }
      if (formattedItem.UpdatedAt) {
        formattedItem.UpdatedAt = format(new Date(`${formattedItem.UpdatedAt}Z`), 'MM/dd/yyyy, h:mm:ss a');
      }
      return formattedItem;
    });

    // Create a new workbook and a worksheet
    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = XLSX.utils.book_new();

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Generate a binary string
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    // Create a Blob and save it as an Excel file
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, `${filename}.xlsx`);
  };

  const filteredData = data.filter((log) => {
    //const logDate = new Date(log.createdDate);

    const userMatch =
      !selectedUser ||
      log.username === selectedUser;

    let dateMatch = true;

    if (startDate || endDate) {

      const logDate = new Date(log.createdDate + "Z");
      logDate.setHours(0, 0, 0, 0);

      const fromDate = startDate ? new Date(startDate) : null;
      const toDate = endDate ? new Date(endDate) : null;

      if (fromDate) {
        fromDate.setHours(0, 0, 0, 0);
      }
      if (toDate) {
        toDate.setHours(23, 59, 59, 999);
      }

      if (fromDate && logDate < fromDate) {
        dateMatch = false;
      }

      if (toDate && logDate > toDate) {
        dateMatch = false;
      }
    }

    return userMatch && dateMatch;
  });

  const sortedData = [...filteredData].sort((a, b) => {
    if (!sortConfig.key) return 0;

    let aValue = a[sortConfig.key];
    let bValue = b[sortConfig.key];

    // Special handling for dates
    if (sortConfig.key === "createdDate") {
      aValue = new Date(aValue);
      bValue = new Date(bValue);
    }

    if (aValue < bValue) {
      return sortConfig.direction === "asc" ? -1 : 1;
    }

    if (aValue > bValue) {
      return sortConfig.direction === "asc" ? 1 : -1;
    }

    return 0;
  });

  const paginatedData = sortedData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleFromDateChange = (e) => {
    const value = e.target.value;
    setStartDate(e.target.value);
    setCurrentPage(1);

    if (endDate && new Date(value) > new Date(endDate)) {
      setDateError("Start Date cannot be greater than End Date");
    } else {
      setDateError("");
    }
  };

  const handleToDateChange = (e) => {
    const value = e.target.value;
    setEndDate(e.target.value);
    setCurrentPage(1);

    if (startDate && new Date(value) < new Date(startDate)) {
      setDateError("End Date cannot be less than Start Date");
    } else {
      setDateError("");
    }
  };

  const userOptions = [
    { value: "", label: "All Users" },
    ...Array.from(
      new Set(data.map(item => item.username))
    ).map(username => ({
      value: username,
      label: username
    }))
  ];

  const handleUserChange = (selectedOption) => {
    setSelectedUser(selectedOption?.value || "");
    setCurrentPage(1);
  };

  const handleSort = (key) => {
    let direction = "asc";

    if (
      sortConfig.key === key &&
      sortConfig.direction === "asc"
    ) {
      direction = "desc";
    }

    setSortConfig({ key, direction });
  };

  //const paginatedData = data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


  return (
    <div className={`p-8 rounded-lg shadow-sm h-[calc(100vh-6rem)] flex flex-col ${isDarkMode ? "bg-[#303031] bg-opacity-90" : "bg-white "
      } text-[#101828] backdrop-blur border-none`}>
      <div className="flex justify-between items-center mb-6">
        <h2 className={`text-[22px] font-500    ${isDarkMode ? "text-[#FFFFFFCC]" : "text-[#464646]"}`}>
          {isLangArab ? "سجل نشاط المستخدمين" : "User Activity Log"}</h2>
        <button onClick={handleExport}
          className="bg-[#3B8686] text-[#FFFFFF] px-4 py-2 rounded-lg font-500   text-sm flex items-center"
        >
          {isLangArab ? "تصدير السجل" : "Export log"}
          {/* <ArrowDown className="ml-2 h-4 w-4" /> */}
          <img src={ExportArrow} className={`${isLangArab ? "mr-2" : "ml-2"} h-4 w-3`} alt="" />
        </button>
      </div>


      <div>
        <div className=" pb-3 rowsAdjustedFlex">
          <div className='rowsAdjustedFlex'>


            <div class="">
              <div class="form-group ">
                <label
                  htmlFor="userFilter"
                  className={`pb-3 p-2 font-500   text-[14px]  ${isLangArab ? "pr-2" : "pr-2"} ${isDarkMode ? "text-[#FFFFFF]" : "text-[#667085]"}`}
                >
                  {isLangArab ? "تاريخ البدء" : "Start Date"} :
                </label>
                <input
                  type="date"
                  name="startDate"
                  value={startDate}
                  onChange={handleFromDateChange}
                  placeholder="Start Date"
                  max={new Date().toISOString().split("T")[0]}
                  className="form-control custom-date-input"
                  style={{ border: "1px solid black", padding: "1px 6px", borderRadius: "7px", marginLeft: "1rem" }}
                />
              </div>
            </div>

            <div class="">
              <div className="form-group">
                <label
                  htmlFor="userFilter"
                  className={`pb-3 p-2 font-500   text-[14px]  ${isLangArab ? "pr-2" : "pr-2"} ${isDarkMode ? "text-[#FFFFFF]" : "text-[#667085]"}`}
                >
                  {isLangArab ? "تاريخ الانتهاء" : "End Date"} :
                </label>
                <input
                  type="date"
                  name="endDate"
                  value={endDate}
                  onChange={handleToDateChange}
                  placeholder="End Date"
                  max={new Date().toISOString().split("T")[0]}
                  className="form-control custom-date-input"
                  style={{ border: "1px solid black", padding: "1px 6px", borderRadius: "7px", marginLeft: "1rem" }}
                />
                {dateError && (
                  <div
                    className={`mt-1 font-500 text-[14px] ${isDarkMode ? "text-red-400" : "text-red-600"
                      }`}
                  >
                    {dateError}
                  </div>
                )}
              </div>
            </div>
            <div className="">
              <div className="form-group">
                <label
                  htmlFor="userFilter"
                  className={`pb-3 p-2 font-500   text-[14px]  ${isLangArab ? "pr-2" : "pr-2"} ${isDarkMode ? "text-[#FFFFFF]" : "text-[#667085]"}`}
                >
                  {isLangArab ? "حدد المستخدم" : "Select User"} :
                </label>

                <select
                  value={selectedUser}
                  onChange={(e) => setSelectedUser(e.target.value)}
                  style={{ border: "1px solid black", padding: "1px 6px", borderRadius: "7px", marginLeft: "1rem" }}
                >
                  {userOptions.map((user) => (
                    <option
                      key={user.value}
                      value={user.value}
                    >
                      {user.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>


          </div>

          <div class="" >
            <button
              onClick={() => {
                setStartDate("");
                setEndDate("");
                setDateError("");
                setSelectedUser("");
                setCurrentPage(1);
              }}
              className="bg-[#3B8686] text-[#FFFFFF] px-4 py-2 rounded-lg font-500   text-sm flex items-center"
            >
              {isLangArab ? "مسح الفلاتر" : "Clear Filters"}
            </button>
          </div>

        </div>
      </div>

      <hr className={`border-t  my-4 ${isDarkMode ? "border-[#FFFFFF] border-opacity-10" : "border-gray-300"}`} />

      <div className="overflow-hidden flex-grow relative">
        <div className="overflow-x-auto overflow-y-auto absolute inset-0">
          <table className="w-full border-collapse">
            <thead className={`sticky top-0   z-10 ${isDarkMode ? "bg-[#303031] " : "bg-white"}`}>
              <tr className={`${isLangArab ? "text-right" : "text-left"} border-b border-[#E5E7EB]`}>
                <th className={`pb-3 p-2 font-500   text-[14px]  ${isLangArab ? "pr-2" : "pr-2"} ${isDarkMode ? "text-[#FFFFFF]" : "text-[#667085]"} cursor-pointer`} onClick={() => handleSort("username")} >
                  {isLangArab ? "اسم المستخدم" : "Username"}</th>
                <th className={`pb-3 p-2 font-500   text-[14px]  ${isLangArab ? "pl-2" : "pr-2"} ${isDarkMode ? "text-[#FFFFFF]" : "text-[#667085]"} cursor-pointer`} onClick={() => handleSort("email")}>
                  {isLangArab ? "معرف البريد الإلكتروني" : "Email ID"}</th>
                <th className={`pb-3 p-2 font-500   text-[14px]  ${isLangArab ? "pl-2" : "pr-32"} ${isDarkMode ? "text-[#FFFFFF]" : "text-[#667085]"} cursor-pointer`} onClick={() => handleSort("createdDate")}>
                  {isLangArab ? "التاريخ والوقت" : "  Date and Time"}</th>
                <th className={`pb-3 p-2 font-500   text-[14px]  ${isLangArab ? "pl-2" : "pr-4"} ${isDarkMode ? "text-[#FFFFFF]" : "text-[#667085]"} cursor-pointer`} onClick={() => handleSort("ipaddress")}>
                  {isLangArab ? "عنوان IP" : "IP Address"}</th>
                <th className={`pb-3 p-2 font-500   text-[14px]  ${isLangArab ? "pl-2" : "pr-10"} ${isDarkMode ? "text-[#FFFFFF]" : "text-[#667085]"} cursor-pointer`} onClick={() => handleSort("action")}>
                  {isLangArab ? "النشاط" : "User Action"}</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((log, index) => (
                <tr key={index} className={`${isDarkMode
                    ? index % 2 === 0
                      ? "bg-transparent"
                      : "bg-white bg-opacity-10"
                    : index % 2 === 0
                      ? "bg-[#D5E5DE] bg-opacity-30"
                      : "bg-white"
                  }`} >
                  <td className={`py-4 font-500   text-[14px]  ${isLangArab ? "pr-2" : "pr-2"} ${isDarkMode ? "text-[#FFFFFF] text-opacity-60" : "text-[#101828]"}`}>{log.username}</td>
                  <td className={`py-4 font-500   text-[14px]  ${isLangArab ? "pl-2" : "pr-2"} ${isDarkMode ? "text-[#FFFFFF] text-opacity-60" : "text-[#101828]"}`}>{log.email}</td>
                  <td dir={isLangArab && "ltr"} className={`py-4 font-500   text-[14px]  ${isLangArab ? " text-right pl-2" : " text-left pr-2"} ${isDarkMode ? "text-[#FFFFFF] text-opacity-60" : "text-[#101828]"}`}>{new Date(`${log.createdDate}Z`).toLocaleString()}</td>
                  <td className={`py-4 font-500   text-[14px]  ${isLangArab ? "pl-2" : "pr-2"} ${isDarkMode ? "text-[#FFFFFF] text-opacity-60" : "text-[#101828]"}`}>{log.ipaddress}</td>
                  <td className={`py-4 font-500   text-[14px]  ${isLangArab ? "pl-2" : "pr-2"} ${isDarkMode ? "text-[#FFFFFF] text-opacity-60" : "text-[#101828]"}`}>{log.action}</td>


                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className=' flex justify-end'>
        <Pagination
          currentPage={currentPage}
          //totalPages={totalItems} 
          totalPages={filteredData.length}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
}
